import React from 'react';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import InViewObserver from 'components/InViewObserver';
import s from './GenericTable.scss';
import ReadMoreLess from '../ReadMoreLess/ReadMoreLess';
import Link from '../../../components/Link/Link';
import { TOI_LIVE_DOMAIN } from '../../../constants';

const GenericTable = ({
  columns = [], // Array of objects defining column properties
  headerTitle,
  tableSubHeading,
  data = [], // Array of objects defining row data
  ga4Type,
  tableClass = '',
  fixedHeader = false,
  fixedFirstColumn = false,
  firstColumnDark = false,
  xAxisScrollable = false,
  tableCellNoWrap = false,
  firstColumnMinWidth130 = false,
  firstColumnSerialNumbers = false,
  firstColumnWidth275 = false,
  isNoHoliday,
  firstRowDark = false,
  hideTableHeader = false,
  customHeader = '',
  isLinked = false,
  ColumnWidth50Percent = false,
  isIplPointsTable = false,
}) => {
  const onView = () => {
    if (ga4Type) {
      analyticsWrapper('ga4', {
        event: 'user_shown',
        type: `${ga4Type}`,
      });
    }
  };

  const renderCellContent = (col, row) => {
    if (
      !col ||
      !isLinked ||
      (col.key !== 'name' && col.key !== 'result' && isIplPointsTable)
    ) {
      return (
        <span
          dangerouslySetInnerHTML={{
            __html:
              row[col.key] !== undefined &&
              row[col.key] !== null &&
              row[col.key] !== '-'
                ? row[col.key]
                : '-',
          }}
        />
      );
    }

    if (row[col.key] === 'name') {
      return (
        <Link
          to={`${TOI_LIVE_DOMAIN}/sports/cricket/ipl/player-stats/${row[col.key]
            ?.split(' ')
            .join('-')
            .toLowerCase()}/${row.id}`}
        >
          {row[col.key]}
        </Link>
      );
    }

    if (col.key === 'result' && isIplPointsTable) {
      return (
        <Link to={row?.matchLink} className={s.LinkArrow}>
          {row?.result} {row?.result && <i className={s.rightArrow} />}
        </Link>
      );
    }

    return (
      <span
        dangerouslySetInnerHTML={{
          __html:
            row[col.key] !== undefined &&
            row[col.key] !== null &&
            row[col.key] !== '-'
              ? row[col.key]
              : '-',
        }}
      />
    );
  };

  return (
    <InViewObserver inViewCallback={onView}>
      <div className={`${tableClass}`}>
        {headerTitle && <h3 className={s.tableHeading}>{headerTitle}</h3>}
        {tableSubHeading && (
          <ReadMoreLess
            information={tableSubHeading}
            readMoreLengthLimit={270}
            ga4Type={ga4Type}
            ga4Params={
              !!ga4Type && {
                event: 'user_click',
                type: ga4Type,
              }
            }
          />
        )}
        {data &&
          data.length > 0 && (
            <div
              className={`${s.tableWrapper} ${
                fixedHeader ? s.fixedHeader : ''
              } ${fixedFirstColumn ? s.fixedFirstColumn : ''}  ${
                firstColumnDark ? s.firstColumnDark : ''
              } ${xAxisScrollable ? s.xAxisScrollable : ''} ${
                tableCellNoWrap ? s.tableCellNoWrap : ''
              } ${firstColumnMinWidth130 ? s.firstColumnMinWidth130 : ''}
              ${firstColumnSerialNumbers ? s.firstColumnSerialNumbers : ''}
              ${ColumnWidth50Percent ? s.ColumnWidth50Percent : ''}
              ${firstColumnWidth275 ? s.firstColumnWidth275 : ''} ${
                firstRowDark ? s.firstRowDark : ''
              }  `}
            >
              <div className={s.table}>
                {!hideTableHeader && (
                  <div className={s.tableHeadGroup}>
                    <div className={s.tableRow}>
                      {columns.map((col, index) => (
                        <div
                          key={index}
                          className={col.className || s.tableCell}
                          style={col.style || {}}
                        >
                          {col.label}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {customHeader && (
                  <div className={s.tableRowGroup}>
                    <div className={`${s.tableRow} ${s.tableRowDark}`}>
                      <div className={s.tableCell}>{customHeader}</div>
                    </div>
                  </div>
                )}
                <div
                  className={`${s.tableRowGroup} ${
                    isNoHoliday ? s.isNoHoliday : ''
                  }    `}
                >
                  {data.map((row, rowIndex) => {
                    // Determine if the value of the key has changed
                    const isKeyChanged =
                      rowIndex > 0 &&
                      data[rowIndex].month !== data[rowIndex - 1].month;
                    return (
                      <div
                        key={row.id || rowIndex}
                        style={{
                          borderTop: isKeyChanged
                            ? '' // Apply darker border if key value changes
                            : undefined,
                        }}
                        className={`${s.tableRow}  ${
                          rowIndex === 0 && firstRowDark ? s.firstRowBlue : ''
                        }`}
                      >
                        {columns.map((col, colIndex) => (
                          <div
                            key={colIndex}
                            className={col.className || s.tableCell}
                            style={col.style || {}}
                          >
                            {renderCellContent(col, row)}
                          </div>
                        ))}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )}
      </div>
    </InViewObserver>
  );
};
export default GenericTable;
